import { render, staticRenderFns } from "./TermsOfServiceOtherLanguages.vue?vue&type=template&id=1b376bac&scoped=true"
import script from "./TermsOfServiceOtherLanguages.vue?vue&type=script&lang=js"
export * from "./TermsOfServiceOtherLanguages.vue?vue&type=script&lang=js"
import style0 from "./TermsOfServiceOtherLanguages.vue?vue&type=style&index=0&id=1b376bac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b376bac",
  null
  
)

export default component.exports